<template>
  <div id="app" :class="computedClasses" >
    <q-layout>
      <div class="header-container">
        <navigation id="desktop-nav"></navigation>
        <mobile-navigation id="mobile-nav"></mobile-navigation>
      </div>
      <secondary-header :class="{'hidden': isRetrieving }" v-if="!isPageContent && !isShowingOnboarding"></secondary-header>
      <div v-if="this.isRetrieving" class="spinner-wrapper">
        <loading></loading>
      </div>
        <div :class="{'main-content': true, 'main-content--lead': isPageLead, 'main-content--projects': isPageProjects, 'main-content--projects': isPageProjectNew, 'empty-state-projects': emptyStateProjects, 'empty-state-leads': emptyStateLeads, 'main-content--manager': isPageContent, 'hidden': isRetrieving}">
          <q-page-container>
            <router-view class="router-view" @logout="$emit('logout')" :key="$route.fullPath"></router-view>
          </q-page-container>
        </div>
      <app-footer/>
    </q-layout>
  </div>
</template>
<script>
import Navigation from '@/components/layouts/partials/Navigation.vue'
import MobileNavigation from '@/components/layouts/partials/MobileNavigation.vue'
import SecondaryHeader from '@/components/layouts/partials/SecondaryHeader.vue'
import Searchbar from '@/components/layouts/partials/Searchbar.vue'
import PasswordReset from '@/components/auth/PasswordReset.vue'
import Loading from '@/components/helpers/Specific/Loading.vue'
import AppFooter from '@/components/layouts/partials/AppFooter'

import Ui from '@/classes/Ui'
import Session from '@/classes/Session'

export default {
  name: 'layout',
  components: {
    AppFooter,
    Navigation,
    SecondaryHeader,
    MobileNavigation,
    Searchbar,
    Loading
  },
  computed: {
    computedClasses(){
      return 'level-' + Ui.getLevel()
    },
    tabs(){
      return this.$store.state.tabs.length > 0
    },
    isPageLead(){
      return this.$route.name == "project_lead_edit"
    },
    isPageLeads(){
      return this.$route.name == "project_leads"
    },
    isPageProjects(){
      return this.$route.name == "projects"
    },
    isPageProjectNew(){
      return this.$route.name == "project_new"
    },
    isPageContent(){
      return this.$route.name == "content_manager"
    },
    isEmptyState() {
      return this.$store.getters.getEmptyState
    },
    emptyStateProjects() {
     return (this.isEmptyState === 'projects') && (this.$route.name == "projects" || "project_new")
   },
    emptyStateLeads() {
      return this.isEmptyState === 'leads' && this.$route.name == "project_leads"
    },
    isRetrieving() {
      return this.$store.getters.getIsRetrieving
    },
    isShowingOnboarding() {
      return !this.$store.getters.getUserIsOnboarded
    }
  },
  watch: {
    $route() {
      // We also close the drawer everytime we change page
      this.$store.commit('SET_DRAWER_VISIBLE', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Layout.vue?2d6bc5f5